import { memo, useCallback, useMemo } from 'react'
import { useAlerts, useStore } from '../../store/index.js'
import type { AlertSeverity, WatchdogAlert } from '../../types/index.js'
import './FeedbackOverlays.css'

const VISIBLE_SEVERITIES: AlertSeverity[] = ['WARNING', 'CRITICAL', 'ERROR']
const ALERT_LABELS: Record<AlertSeverity, string> = {
  OK: 'OK',
  WARNING: 'Alerte',
  CRITICAL: 'Critique',
  ERROR: 'Erreur',
}

function formatAlertTime(ts: string): string {
  const date = new Date(ts)
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleTimeString()
}

const OperatorAlertCard = memo(function OperatorAlertCard({ alert }: { alert: WatchdogAlert }) {
  const dismissAlert = useStore(state => state.dismissAlert)
  const handleDismiss = useCallback(() => dismissAlert(alert.type, alert.itemId), [alert.itemId, alert.type, dismissAlert])

  return (
    <button
      type="button"
      title="Cliquer pour retirer l'alerte"
      onClick={handleDismiss}
      className={`tp-operator-alert is-${alert.severity.toLowerCase()}`}
    >
      <span className="tp-operator-alert__meta">
        <strong>{ALERT_LABELS[alert.severity]}</strong>
        <span>{formatAlertTime(alert.ts)}</span>
      </span>
      <span className="tp-operator-alert__message">{alert.message}</span>
    </button>
  )
})

export const OperatorAlertPopups = memo(function OperatorAlertPopups() {
  const alerts = useAlerts()
  const visibleAlerts = useMemo(
    () => alerts.filter(alert => VISIBLE_SEVERITIES.includes(alert.severity)).slice(0, 5),
    [alerts],
  )

  if (!visibleAlerts.length) return null

  return (
    <div className="tp-operator-alert-stack" aria-live="assertive">
      {visibleAlerts.map(alert => (
        <div key={`${alert.type}:${alert.itemId ?? 'global'}`} className="tp-feedback-interactive">
          <OperatorAlertCard alert={alert} />
        </div>
      ))}
    </div>
  )
})
